<script>
import {
  listRecords,
  findConpany,
  findThisConpany,
  baseAdd,
  ChaChong,
  getUserId,
  exportExcel
} from "../../../api/crm";
import TextHighlight from 'vue-text-highlight'
import { searchUserListExclude } from "../../../api/auth/user";
import { searchOrganizationList } from "../../../api/auth/organization";
import { getDict } from "../../../api/dict";
import moment from "moment";
import chinaCitys from "@/plugins/ChinaCitys.json";
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
export default {
  name: "recordsList",
  computed: {
    areas1() {
      return this.selectedCity?.areas || [];
    },
    lang() {
      return this.$store.state.lang;
    }
  },
  components: {TextHighlight},
  data() {
    return {
      
      list: [],
      dialogFormVisible: false,
      dialogTableVisible: false,
      queryParams:{
        company:'',
        reportMan:'',
        saleman:'',
        companyAddress:'',
        linkman:'',
        linkmanNum:'',
        policymaker:'',
        policymakerNum:'',
        customerDemand:'',
        zz:'',
        note:'',
        customerBelong:'',
      },
      highLightInfo:{
        company:[],
        reportMan:[],
        saleman:[],
        companyAddress:[],
        linkman:[],
        linkmanNum:[],
        policymaker:[],
        policymakerNum:[],
        customerDemand:[],
        zz:[],
        note:[],
        customerBelong:[],
      },
      anniu: false,
      options: [],
      value: [],
      list: [],
      options8: [],
      loading: false,
      loading1: false,
      selectedProvince: {},
      multipleSelection: [],
      selectedCity: {},
      recordsIds: [],
      companyDetail: {},
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      fileList: [],
      en,
      zh,
      china: chinaCitys,
      formLabelWidth: "120px",
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30", "40", "50"],
        showSizeChanger: true
      },
      ruleForm: {
        reportTime: "",
        reportMan: "",
        saleman: "",
        reportManId: "",
        salemanId: "",
        company: "",
        ssq: "",
        zz: "",
        companyAddress: "",
        linkman: "",
        linkmanNum: "",
        policymaker: "",
        policymakerNum: "",
        customerDemand: "",
        informationSources: "",
        originalModel: "",
        estimatedPurchaseTime: "",
        isorder: "",
        note: "",
        customerBelong: "",
        state: "",
        cdjx: ""
      },
      zsArray: [],
      select: {
        searchParam: "",
        reportStartTime: "",
        reportEndTime: "",
        isorder: "",
        state: "",
        px: "0",
        isMy: "0"
      },
      Ttitle: "",
      CCresult: "",
      value2: "",
      rules: {},
      pageNo: 1,
      limit: 50,
      total: 0,
      formLabelWidth: "120px",
      companyList: [],
      isCompanyLoading: false,
      allA: {},
      allowTJ: false,
      zzid: "",
      p: "",
      youid: "",
      reuserList: [],
      userList: [],
      c: "",
      area: "",
      zhen: "",
      options0: [],
      options1: [],
      options3: [],
      options10: [],
      cxzhen: [
        "浒山街道",
        "白沙路街道",
        "古塘街道",
        "宗汉街道",
        "坎墩街道",
        "匡堰镇",
        "逍林镇",
        "龙山镇",
        "掌起镇",
        "观海卫镇",
        "附海镇",
        "桥头镇",
        "胜山镇",
        "横河镇",
        "长河镇",
        "崇寿镇",
        "新浦镇",
        "周巷镇",
        "庵东镇",
        "杭州湾新区"
      ],
      authorities: []
    };
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate();
      }
    }
  },
  async created() {
    const a = JSON.parse(sessionStorage.getItem("authorities"));
    if (a?.length) {
      this.authorities = a;
    } else {
      this.authorities = this.getAuthorities(this.$route.path);
    }
    const b = await getUserId();
    if (b) {
      this.zzid = b.data.zzid;
      this.youid = b.data.id;
    }
    this.ListC();
  },
  mounted() {},
  methods: {
    async translate() {
      locale.use(this[this.lang])
      this.rules = {
        reportTime: [
          {
            type: "date",
            required: true,
            message: this.$t("device.selectDate"),
            trigger: "blur"
          }
        ],
        reportMan: [
          {
            required: true,
            message: this.$t("recordDetail.er"),
            trigger: "blur"
          }
        ],
        saleman: [
          {
            required: true,
            message: this.$t("recordDetail.es"),
            trigger: "blur"
          }
        ],
        company: [
          {
            required: true,
            message: this.$t("messages.company_empty"),
            trigger: "blur"
          }
        ],
        ssq: [
          {
            required: true,
            message: this.$t("recordDetail.sa"),
            trigger: "blur"
          }
        ],
        linkman: [
          {
            required: true,
            message: this.$t("recordDetail.el"),
            trigger: "blur"
          }
        ],
        linkmanNum: [
          {
            required: true,
            message: this.$t("recordDetail.eln"),
            trigger: "blur"
          },
          { min: 6, message: this.$t("recordsList.char6"), trigger: "blur" }
        ],
        policymaker: [
          {
            required: true,
            message: this.$t("recordDetail.ek"),
            trigger: "blur"
          }
        ],
        companyAddress: [
          {
            required: true,
            message: this.$t("recordsList.address"),
            trigger: "blur"
          },
          { min: 6, message: this.$t("recordsList.char6"), trigger: "blur" }
        ],
        policymakerNum: [
          {
            required: true,
            message: this.$t("recordDetail.ekn"),
            trigger: "blur"
          },
          { min: 6, message: this.$t("recordsList.char6"), trigger: "blur" }
        ],
        customerDemand: [
          {
            required: true,
            message: this.$t("recordDetail.ecd"),
            trigger: "blur"
          }
        ],
        originalModel: [
          {
            required: true,
            message: this.$t("recordDetail.eom"),
            trigger: "blur"
          }
        ],
        estimatedPurchaseTime: [
          {
            required: true,
            message: this.$t("recordDetail.eept"),
            trigger: "blur"
          }
        ],
        informationSources: [
          {
            required: true,
            message: this.$t("recordDetail.sis"),
            trigger: "change"
          }
        ],
        customerBelong: [
          {
            required: true,
            message: this.$t("recordDetail.ecb"),
            trigger: "blur"
          }
        ]
      };
      this.options0 = [
        {
          value: "",
          label: this.$t("common.all")
        },
        {
          value: "1",
          label: this.$t("report46.unaudited")
        },
        { value: "2", label: this.$t("recordDetail.reportValid") },
        { value: "3", label: this.$t("recordDetail.reportInvalid") },
        { value: "4", label: this.$t("recordsList.overdue") }
      ];
      this.options1 = [
        {
          value: "",
          label: this.$t("common.all")
        },
        {
          value: "0",
          label: this.$t("recordDetail.nOrdered")
        },
        { value: "1", label: this.$t("recordDetail.ordered") }
      ];
      this.options3 = [
        {
          value: "0",
          label: this.$t("recordsList.recordTime")
        },
        {
          value: "1",
          label: this.$t("recordsList.expirationTime")
        }
      ];
      this.options8 = await this.getOption("informationSources");
      this.options10 = [
        {
          value: "0",
          label: this.$t("recordsList.myReport")
        },
        {
          value: "1",
          label: this.$t("recordsList.elseReport")
        }
      ];
    },
    async Select() {
      await this.ListC();
    },
    refresh() {
      this.select.searchParam = "";
      this.value2 = "";
      this.select.state = "";
      this.select.isorder = "";
      this.select.reportStartTime = "";
      this.select.reportEndTime = "";
    },
    async getOption(a) {
      const lang = this.lang === "en" ? "en-US" : "zh-CN";
      const result = await getDict(lang, a);
      if (result.code == 0) {
        return result.data.content;
      }
    },
    async ListC(pager = 1) {
      this.loading1 = true
      this.pageNo = pager;
      const formdata = new FormData();
      if (this.value2 != "" && this.value2) {
        this.select.reportStartTime = moment(+this.value2[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.select.reportEndTime = moment(+this.value2[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      formdata.append("searchParam", this.select.searchParam);
      formdata.append("reportStartTime", this.select.reportStartTime);
      formdata.append("reportEndTime", this.select.reportEndTime);
      formdata.append("isorder", this.select.isorder);
      formdata.append("state", this.select.state);
      formdata.append("px", this.select.px);
      formdata.append("isMy", this.select.isMy);
      formdata.append("company", this.queryParams.company);
      formdata.append("reportMan", this.queryParams.reportMan);
       formdata.append("saleman", this.queryParams.saleman);
       formdata.append("companyAddress", this.queryParams.companyAddress);
       formdata.append("linkman", this.queryParams.linkman);
       formdata.append("linkmanNum", this.queryParams.linkmanNum);
       formdata.append("policymaker", this.queryParams.policymaker);
       formdata.append("policymakerNum", this.queryParams.policymakerNum);
       formdata.append("customerDemand", this.queryParams.customerDemand);
       formdata.append("zz", this.queryParams.zz);
       formdata.append("note", this.queryParams.note);
      const result = await listRecords(this.pageNo, this.limit, formdata);
      if (result.code == 0) {
        this.total = result.data.total;
        result.data.records.forEach(e => {
          if (e.state == "1") {
            e.state1 = this.$t("report46.unaudited");
          } else if (e.state == "2") {
            e.state1 = this.$t("recordDetail.reportValid");
          } else if (e.state == "3") {
            e.state1 = this.$t("recordDetail.reportInvalid");
          } else if (e.state == "4") {
            e.state1 = this.$t("recordsList.overdue");
          }
          if (e.isorder == "0") {
            e.isorder1 = this.$t("recordDetail.nOrdered");
          } else if (e.isorder == "1") {
            e.isorder1 = this.$t("recordDetail.ordered");
          }
        });
        this.list = result.data.records;
       this.highLightInfo.company = [this.select.searchParam,this.queryParams.company]
       this.highLightInfo.reportMan = [this.select.searchParam,this.queryParams.reportMan]
       this.highLightInfo.saleman = [this.select.searchParam,this.queryParams.saleman]
       this.highLightInfo.companyAddress = [this.select.searchParam,this.queryParams.companyAddress]
       this.highLightInfo.linkman = [this.select.searchParam,this.queryParams.linkman]
       this.highLightInfo.linkmanNum = [this.select.searchParam,this.queryParams.linkmanNum]
       this.highLightInfo.policymaker = [this.select.searchParam,this.queryParams.policymaker]
       this.highLightInfo.policymakerNum = [this.select.searchParam,this.queryParams.policymakerNum]
       this.highLightInfo.customerDemand = [this.select.searchParam,this.queryParams.customerDemand]
       this.highLightInfo.zz = [this.select.searchParam,this.queryParams.zz]
       this.highLightInfo.note = [this.select.searchParam,this.queryParams.note]
       this.highLightInfo.customerBelong = [this.select.searchParam]
      } else {
        this.$notify.error({
          title: this.$t("messages.error"),
          message: result.message
        });
      }
      this.loading1 = false
    },
    async ListC1(val) {
      this.limit = val;
      const formdata = new FormData();
      if (this.value2 != "" && this.value2) {
        this.select.reportStartTime = moment(+this.value2[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.select.reportEndTime = moment(+this.value2[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      formdata.append("searchParam", this.select.searchParam);
      formdata.append("reportStartTime", this.select.reportStartTime);
      formdata.append("reportEndTime", this.select.reportEndTime);
      formdata.append("isorder", this.select.isorder);
      formdata.append("state", this.select.state);
      formdata.append("px", this.select.px);
       formdata.append("company", this.queryParams.company);
       formdata.append("reportMan", this.queryParams.reportMan);
       formdata.append("saleman", this.queryParams.saleman);
       formdata.append("companyAddress", this.queryParams.companyAddress);
       formdata.append("linkman", this.queryParams.linkman);
       formdata.append("linkmanNum", this.queryParams.linkmanNum);
       formdata.append("policymaker", this.queryParams.policymaker);
       formdata.append("policymakerNum", this.queryParams.policymakerNum);
       formdata.append("customerDemand", this.queryParams.customerDemand);
       formdata.append("zz", this.queryParams.zz);
       formdata.append("note", this.queryParams.note);
      const result = await listRecords(this.pageNo, this.limit, formdata);
      if (result.code == 0) {
        this.total = result.data.total;
        result.data.records.forEach(e => {
          if (e.state == "1") {
            e.state1 = this.$t("report46.unaudited");
          } else if (e.state == "2") {
            e.state1 = this.$t("recordDetail.reportValid");
          } else if (e.state == "3") {
            e.state1 = this.$t("recordDetail.reportInvalid");
          } else if (e.state == "4") {
            e.state1 = this.$t("recordsList.overdue");
          }
        });
        this.list = result.data.records;
       this.highLightInfo.company = [this.select.searchParam,this.queryParams.company]
       this.highLightInfo.reportMan = [this.select.searchParam,this.queryParams.reportMan]
       this.highLightInfo.saleman = [this.select.searchParam,this.queryParams.saleman]
       this.highLightInfo.companyAddress = [this.select.searchParam,this.queryParams.companyAddress]
       this.highLightInfo.linkman = [this.select.searchParam,this.queryParams.linkman]
       this.highLightInfo.linkmanNum = [this.select.searchParam,this.queryParams.linkmanNum]
       this.highLightInfo.policymaker = [this.select.searchParam,this.queryParams.policymaker]
       this.highLightInfo.policymakerNum = [this.select.searchParam,this.queryParams.policymakerNum]
       this.highLightInfo.customerDemand = [this.select.searchParam,this.queryParams.customerDemand]
       this.highLightInfo.zz = [this.select.searchParam,this.queryParams.zz]
       this.highLightInfo.note = [this.select.searchParam,this.queryParams.note]
       this.highLightInfo.customerBelong = [this.select.searchParam]
      } else {
        this.$notify.error({
          title: this.$t("messages.error"),
          message: result.message
        });
      }
    },
    routeTo(row) {
      this.$router.push({
        path: "/recordsListDetail",
        query: { id: row.id }
      });
    },
    async openAdd() {
      this.ruleForm.reportTime = +new Date();
      this.ruleForm.reportMan = localStorage.getItem("nick");
      this.ruleForm.saleman = localStorage.getItem("nick");
      this.ruleForm.salemanId = this.youid;
      this.ruleForm.reportManId = this.youid;
      const result = await searchOrganizationList(1, 10, {
        filter: [{ field: "id", value: this.zzid }],
        query: [],
        sort: [{ field: "updatedAt", value: "DESC" }]
      });
      if (result.code == 0) {
        this.ruleForm.zz = result.data.records[0].details.find(
          i => i.locale == "zh-CN"
        ).name;
      } else {
        this.$notify.error({
          title: this.$t("messages.error"),
          message: result.message
        });
      }
      this.dialogFormVisible = true;
    },
    async findC() {
      const result = await findConpany("1", "20", this.ruleForm.company);
      if (result && result.code == 0) {
        this.companyList = result.data.records;
      }
    },

    handleCBlur() {
      this.isCompanyListShow = false;
      this.companyList = [];
    },

    remoteMethod(e) {
      if (e.length >= 2) {
        this.ruleForm.company = e;
        this.loading = true;
        this.findC();
        this.options = this.companyList;
        this.loading = false;
      }
    },

    selectSheng() {
      console.log(this.p);
      if (this.p != this.selectedProvince.name) {
        this.c = "";
        this.area = "";
        this.ruleForm.ssq = "";
      }
      this.selectedProvince = this.china.find(item => {
        if (item.province == this.p) {
          return item;
        }
      });
      this.selectedCity = {};
    },

    selectCity() {
      if (this.c != this.selectedCity?.city) {
        this.area = "";
        this.ruleForm.ssq = "";
      }
      this.selectedCity = this.selectedProvince.citys.find(
        item => item.city == this.c
      );
      return this.selectedCity;
    },

    // 区
    selectArea() {
      this.ruleForm.ssq = this.p + "/" + this.c + "/" + this.area;
      console.log(this.ruleForm.ssq)
    },

    selectzhen() {
      this.ruleForm.ssq = this.ruleForm.ssq + "/" + this.zhen;
    },

    async clickThis() {
      const result = await findThisConpany(this.ruleForm.company);
      if (result.code == 0 && result.data) {
        this.companyDetail = result.data;
        this.ruleForm.companyAddress = this.companyDetail.regLocation;
        this.p = this.companyDetail.province;
        if (this.p != "" && this.p != null) {
          await this.selectSheng();
        }
        if (this.companyDetail.city == "市辖区") {
          this.c = this.companyDetail.province;
        } else {
          this.c = this.companyDetail.city;
        }
        console.log(this.c);
        if (this.c != "" && this.c != null) {
          const jieshou = await this.selectCity();
          console.log(jieshou);
          if (!jieshou) {
            this.c = "";
            return;
          }
        }
        this.area = this.companyDetail.district;
        if (this.area != "" && this.area != null) {
          await this.selectArea();
        }
      } else {
        this.$notify.error({
          title: this.$t("messages.error"),
          message: this.$t("messages.spk")
        });
      }
    },

    async allowAdd(a) {
      this.$refs[a].validate(async valid => {
        if (valid) {
          const formdata = new FormData();
          formdata.append(
            "reportTime",
            moment(+this.ruleForm.reportTime).format("YYYY-MM-DD HH:mm:ss")
          );
          formdata.append("reportMan", this.ruleForm.reportMan);
          formdata.append("saleman", this.ruleForm.saleman);
          formdata.append("company", this.ruleForm.company);
          formdata.append("ssq", this.ruleForm.ssq);
          formdata.append("zz", this.ruleForm.zz);
          formdata.append("companyAddress", this.ruleForm.companyAddress);
          formdata.append("linkman", this.ruleForm.linkman);
          formdata.append("linkmanNum", this.ruleForm.linkmanNum);
          formdata.append("policymaker", this.ruleForm.policymaker);
          formdata.append("policymakerNum", this.ruleForm.policymakerNum);

          formdata.append("customerDemand", this.ruleForm.customerDemand);
          formdata.append(
            "informationSources",
            this.ruleForm.informationSources
          );
          formdata.append("originalModel", this.ruleForm.originalModel);

          formdata.append(
            "estimatedPurchaseTime",
            this.ruleForm.estimatedPurchaseTime
          );

          formdata.append("isorder", "0");
          formdata.append("isover", "0");
          formdata.append("note", this.ruleForm.note);
          formdata.append("state", "1");
          this.fileList.map(file => {
            formdata.append("files", file);
          });
          const result = await baseAdd(formdata);
          if (result.code == 0) {
            this.$notify.success({
              title: this.$t("messages.success"),
              message: result.message
            });
            await this.ListC();
            this.dialogFormVisible = false;
          } else {
            this.$notify.error({
              title: this.$t("messages.error"),
              message: result.message
            });
          }
        } else {
          return false;
        }
      });
    },

    showFileModal() {
      this.$refs.InputFileDOm.click();
    },
    onBeforeUpload(file) {
      let acceptTypes;

      acceptTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "video/mp4",
        "video/webm"
      ];

      if (file.size > 1024 * 1024 * 500) {
        // 文件大于 30M 时取消上传
        ElNotification({
          type: "error",
          message: this.$t("messages.lessThan500MB")
        });
        return false;
      }
      if (!acceptTypes.includes(file.type)) {
        // 继续上传
        ElNotification({
          type: "error",
          message: this.$t("messages.rightFile")
        });
        return false; // 停止上传
      }
      return true;
    },
    hadnleFileCHnage(e, a) {
      let i;
      for (i = 0; i < e.target.files.length; i++) {
        if (!this.onBeforeUpload(e.target.files[i])) {
          break;
        }
      }
      if (i == e.target.files.length) {
        this.fileList = this.fileList.concat(Array.from(e.target.files));
      }
    },
    rF(i) {
      this.$Mconfirm(this.$t("messages.ctrd"), this.$t("messages.hint"), {
        confirmButtonText: this.$t("common.okText"),
        cancelButtonText: this.$t("common.cancelText"),
        type: "warning"
      })
        .then(() => {
          const arr = [...this.fileList];
          arr.splice(i, 1);
          this.fileList = arr;
          this.$forceUpdate();
          this.$EM({
            type: "success",
            message: this.$t("messages.rs")
          });
          return true;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("messages.cr")
          });
        });
    },
    guanbi(a) {
      if (a) {
        a();
      } else {
        this.dialogFormVisible = false;
      }
      this.ruleForm = {
        reportTime: "",
        reportMan: "",
        saleman: "",
        reportManId: "",
        salemanId: "",
        company: "",
        ssq: "",
        companyAddress: "",
        linkman: "",
        linkmanNum: "",
        policymaker: "",
        policymakerNum: "",
        customerDemand: "",
        zz: "",
        informationSources: "",
        customerBelong: "",
        originalModel: "",
        estimatedPurchaseTime: "",
        isorder: "",
        note: "",
        state: "1"
      };
      this.anniu = false;
      this.p = "";
      this.c = "";
      this.area = "";
      this.zhen = "";
      this.fileList = [];
    },
    async baseaddCC() {
      const formdata = new FormData();
      if (
        this.ruleForm.company != "" &&
        this.ruleForm.company != null &&
        this.ruleForm.linkmanNum != "" &&
        this.ruleForm.linkmanNum != null &&
        this.ruleForm.policymakerNum != "" &&
        this.ruleForm.policymakerNum != null &&
        this.ruleForm.reportMan != "" &&
        this.ruleForm.reportMan != null
      ) {
        formdata.append("company", this.ruleForm.company);
        formdata.append("reportMan", this.ruleForm.reportMan);
        formdata.append("linkmanNum", this.ruleForm.linkmanNum);
        formdata.append("policymakerNum", this.ruleForm.policymakerNum);
        const result = await ChaChong(formdata);

        this.CCresult = result.data;
        if (this.CCresult == 1) {
          this.$message.success(result.message);
        } else if (this.CCresult == 2) {
          this.$message.info(result.message);
        } else if (!Array.isArray(this.CCresult)) {
          if ("ygkcus" in this.CCresult) {
            for (let i in this.CCresult["ygkcus"]) {
              this.CCresult["ygkcus"][i].salemandd = "";
              // if(Array.isArray(this.CCresult['ygkcus'][i].salesmen)){
              //   for(let item in this.CCresult['ygkcus'][i].salesmen){
              //     this.CCresult['ygkcus'][i].salemandd = this.CCresult['ygkcus'][i].salesmen[item]+ ' '
              //   }

              // }
              this.zsArray.push({
                reportTime: this.CCresult["ygkcus"][i].createdAt,
                company: this.CCresult["ygkcus"][i].company,
                saleman: this.CCresult["ygkcus"][i].salesmen
              });
            }
          } else {
          }
          if ("list204" in this.CCresult) {
            for (let ii in this.CCresult["list204"]) {
              this.zsArray.push(this.CCresult["list204"][ii]);
            }
          } else {
          }
          this.Ttitle = this.$t("recordDetail.oldCustomerInfo");
          this.dialogTableVisible = true;
        } else if (Array.isArray(this.CCresult)) {
          this.zsArray = this.CCresult;
          this.Ttitle = this.$t("recordDetail.reportedInfo");
          this.dialogTableVisible = true;
        }
      } else {
        this.$message.info(this.$t("recordDetail.completeForm"));
      }
    },
    closeTable() {
      this.zsArray = [];
      this.allowTJ = false;
    },
    async jxAdd() {
      this.anniu = true;
      const formdata = new FormData();
      formdata.append(
        "reportTime",
        moment(+this.ruleForm.reportTime).format("YYYY-MM-DD HH:mm:ss")
      );
      formdata.append("reportMan", this.ruleForm.reportMan);
      formdata.append("saleman", this.ruleForm.saleman);
      formdata.append("company", this.ruleForm.company);
      formdata.append("ssq", this.ruleForm.ssq);
      formdata.append("zz", this.ruleForm.zz);
      formdata.append("companyAddress", this.ruleForm.companyAddress);
      formdata.append("linkman", this.ruleForm.linkman);
      formdata.append("linkmanNum", this.ruleForm.linkmanNum);

      formdata.append("policymaker", this.ruleForm.policymaker);
      if (this.ruleForm.salemanId != "" && this.ruleForm.salemanId != null) {
        formdata.append("salemanId", this.ruleForm.salemanId);
      }
      if (
        this.ruleForm.reportManId != "" &&
        this.ruleForm.reportManId != null
      ) {
        formdata.append("reportManId", this.ruleForm.reportManId);
      }
      if (this.ruleForm.zzid != "" && this.ruleForm.zzid != null) {
        formdata.append("zzid", this.ruleForm.zzid);
      }
      formdata.append("policymakerNum", this.ruleForm.policymakerNum);
      formdata.append("customerDemand", this.ruleForm.customerDemand);
      formdata.append("informationSources", this.ruleForm.informationSources);
      formdata.append("originalModel", this.ruleForm.originalModel);

      formdata.append(
        "estimatedPurchaseTime",
        this.ruleForm.estimatedPurchaseTime
      );

      formdata.append("isorder", "0");
      formdata.append("isover", "0");
      formdata.append("note", this.ruleForm.note);
      formdata.append("state", "1");
      this.fileList.map(file => {
        formdata.append("files", file);
      });
      const result = await baseAdd(formdata);
      if (result.code == 0) {
        this.$notify.success({
          title: this.$t("messages.success"),
          message: result.message
        });
        await this.ListC();
        this.dialogTableVisible = false;
        this.dialogFormVisible = false;
      } else {
        this.$notify.error({
          title: this.$t("messages.error"),
          message: result.message
        });
      }
      this.anniu = false;
    },
    async firstQ(a) {
      this.$refs[a].validate(async valid => {
        if (valid) {
          this.anniu = true;
          const formdata = new FormData();
          if (
            this.ruleForm.company != "" &&
            this.ruleForm.company != null &&
            this.ruleForm.linkmanNum != "" &&
            this.ruleForm.linkmanNum != null &&
            this.ruleForm.policymakerNum != "" &&
            this.ruleForm.policymakerNum != null
          ) {
            formdata.append("company", this.ruleForm.company);
            formdata.append("reportMan", this.ruleForm.reportMan);
            formdata.append("linkmanNum", this.ruleForm.linkmanNum);
            formdata.append("policymakerNum", this.ruleForm.policymakerNum);
            const result = await ChaChong(formdata);
            this.CCresult = result.data;

            if (this.CCresult == 1) {
              this.$message.success(result.message);
              const formdata = new FormData();
              formdata.append(
                "reportTime",
                moment(+this.ruleForm.reportTime).format("YYYY-MM-DD HH:mm:ss")
              );
              formdata.append("reportMan", this.ruleForm.reportMan);
              formdata.append("saleman", this.ruleForm.saleman);
              formdata.append("company", this.ruleForm.company);
              formdata.append("zz", this.ruleForm.zz);
              formdata.append("ssq", this.ruleForm.ssq);
              formdata.append("companyAddress", this.ruleForm.companyAddress);

              formdata.append("linkman", this.ruleForm.linkman);
              if (
                this.ruleForm.salemanId != "" &&
                this.ruleForm.salemanId != null
              ) {
                formdata.append("salemanId", this.ruleForm.salemanId);
              }
              if (
                this.ruleForm.reportManId != "" &&
                this.ruleForm.reportManId != null
              ) {
                formdata.append("reportManId", this.ruleForm.reportManId);
              }
              if (this.ruleForm.zzid != "" && this.ruleForm.zzid != null) {
                formdata.append("zzid", this.ruleForm.zzid);
              }
              formdata.append("linkmanNum", this.ruleForm.linkmanNum);
              formdata.append("policymaker", this.ruleForm.policymaker);
              formdata.append("policymakerNum", this.ruleForm.policymakerNum);
              formdata.append("customerDemand", this.ruleForm.customerDemand);
              formdata.append(
                "informationSources",
                this.ruleForm.informationSources
              );
              formdata.append("originalModel", this.ruleForm.originalModel);

              formdata.append(
                "estimatedPurchaseTime",
                this.ruleForm.estimatedPurchaseTime
              );

              formdata.append("isorder", "0");
              formdata.append("isover", "0");
              formdata.append("note", this.ruleForm.note);
              formdata.append("state", "2");
              this.fileList.map(file => {
                formdata.append("files", file);
              });
              const result1 = await baseAdd(formdata);
              if (result.code == 0) {
                this.$notify.success({
                  title: this.$t("messages.success"),
                  message: result1.message
                });
                await this.ListC();
                this.dialogFormVisible = false;
              } else {
                this.$notify.error({
                  title: this.$t("messages.error"),
                  message: result1.message
                });
              }
            } else if (this.CCresult == 2) {
              this.$message.info(result.message);
            } else if (!Array.isArray(this.CCresult)) {
              if ("ygkcus" in this.CCresult) {
                for (let i in this.CCresult["ygkcus"]) {
                  this.CCresult["ygkcus"][i].salemandd = "";
                  // if(Array.isArray(this.CCresult['ygkcus'][i].salesmen)){
                  //   for(let item in this.CCresult['ygkcus'][i].salesmen){
                  //     this.CCresult['ygkcus'][i].salemandd = this.CCresult['ygkcus'][i].salesmen[item]+ ' '
                  //   }

                  // }
                  this.zsArray.push({
                    reportTime: this.CCresult["ygkcus"][i].createdAt,
                    company: this.CCresult["ygkcus"][i].company,
                    saleman: this.CCresult["ygkcus"][i].salesmen
                  });
                }
              } else {
              }
              if ("list204" in this.CCresult) {
                for (let ii in this.CCresult["list204"]) {
                  this.zsArray.push(this.CCresult["list204"][ii]);
                }
              } else {
              }
              this.Ttitle = this.$t("recordDetail.oldCustomerInfo");
              this.allowTJ = true;
              this.dialogTableVisible = true;
            } else if (Array.isArray(this.CCresult)) {
              this.zsArray = this.CCresult;
              this.Ttitle = this.$t("recordDetail.reportedInfo");
              this.allowTJ = true;
              this.dialogTableVisible = true;
            }
          } else {
            this.$message.info(this.$t("recordDetail.completeForm"));
          }
          this.anniu = false;
        } else {
          return false;
        }
      });
    },
    async clickThis1(a) {
      this.ruleForm.salemanId = a.id;
    },
    async clickThis2(a) {
      this.ruleForm.reportManId = a.id;
      this.ruleForm.zzid = a.organizationId;
      this.ruleForm.zz = a.organization;
    },
    remoteMethod1(e) {
      if (e.length >= 1) {
        this.loading = true;
        this.zhaoren(e);
        this.options = this.userList;
        this.loading = false;
      }
    },
    remoteMethod2(e) {
      if (e.length >= 1) {
        this.loading = true;
        this.zhaoren1(e);
        this.options = this.reuserList;
        this.loading = false;
      }
    },
    async zhaoren(e) {
      const result = await searchUserListExclude(1, 15, {
        filter: [],
        query: [{ field: "realName", value: e }],
        sort: [{ field: "updatedAt", value: "DESC" }]
      });
      this.userList = result.data.records;
    },
    async zhaoren1(e) {
      const result = await searchUserListExclude(1, 15, {
        filter: [],
        query: [{ field: "realName", value: e }],
        sort: [{ field: "updatedAt", value: "DESC" }]
      });
      this.reuserList = result.data.records;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.select.isMy == "0") {
        if (row.isorder == 1) {
          return "isorder-row";
        } else if (row.state == 3) {
          return "warning-row";
        } else if (row.state == 2) {
          return "success-row";
        } else if (row.state == 4) {
          return "leave-row";
        }
      } else if (this.select.isMy == "1") {
        if (row.isorder == 1) {
          return "isorder-row";
        } else {
          return "not-row";
        }
      }

      return "";
    },
    async exportEx() {
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.multipleSelection.forEach(i => {
          this.recordsIds.push(i.id);
        });
        const formdata = new FormData();
        formdata.append("RecordIds", this.recordsIds);

        const result = await exportExcel(formdata);
        if (result) {
          const url = window.URL.createObjectURL(
            new Blob([result.data], { type: "application/xlsx" })
          );
          const b = document.createElement("a");
          b.download = this.$t("recordDetail.reportRecord") + ".xlsx";
          b.href = url;
          b.click();
          URL.revokeObjectURL(url);
          if (this.multipleSelection) {
            this.$refs.multipleTable.clearSelection();
          }
          this.recordsIds = [];
        } else {
          this.$message.error(result.message);
        }
      } else if (this.multipleSelection && this.multipleSelection.length < 1) {
        this.$message.error(this.$t("recordsList.empty"));
      }
    },
    async qie() {
      this.list = [];
      await this.ListC();
    }
  }
};
</script>

<template>
  <div>
    <el-card class="box-card">
      <el-form style="width: 100%;" :inline="true">
        <el-form-item :label="$t('recordsList.keyword')" label-width="100px">
          <el-input v-model.trim="select.searchParam" @keyup.enter.native="ListC()" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dataReport.datetime')" label-width="100px">
          <div class="block">
            <el-date-picker
              v-model="value2"
              type="daterange"
              unlink-panels
              range-separator="-"
              :start-placeholder="$t('common.startTime')"
              :end-placeholder="$t('common.endTime')"
              size="default"
            />
          </div>
        </el-form-item>
        <el-form-item :label="$t('recordDetail.state')" label-width="100px">
          <el-select v-model="select.state" class="m-2" placeholder>
            <el-option
              v-for="item in options0"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('recordDetail.isorder')" label-width="100px">
          <el-select v-model="select.isorder" class="m-2" placeholder>
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('recordsList.order')" label-width="100px">
          <el-select v-model="select.px" class="m-2" placeholder>
            <el-option
              v-for="item in options3"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('recordsList.type')" label-width="100px">
          <el-select v-model="select.isMy" class="m-2" placeholder @change="qie">
            <el-option
              v-for="item in options10"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
         <el-button
        type="primary"
        size="default"
        icon="Search"
        @click="Select"
      >{{ $t('buttons.search') }}</el-button>
      <el-button
        type="primary"
        size="default"
        icon="Refresh"
        @click="refresh"
      >{{ $t('buttons.reset') }}</el-button>
      </el-form>
     
    </el-card>
    <el-button
      type="primary"
      size="small"
      style="margin: 5px 5px;float: left;"
      @click="exportEx"
    >{{ $t('buttons.export') }}EXCEL</el-button>
    <el-button
      type="primary"
      size="small"
      style="margin: 5px 5px;float: right;"
      @click="openAdd"
    >{{ $t('recordsList.add') }}</el-button>
    <div class="state1"></div>
    <div style="margin-top: 4px;float:left;font-size:20px">{{ $t('recordDetail.reportValid') }}</div>
    <div class="state2"></div>
    <div style="margin-top: 4px;float:left;font-size:20px">{{ $t('recordDetail.reportInvalid') }}</div>
    <div class="state3"></div>
    <div style="margin-top: 4px;float:left;font-size:20px">{{ $t('recordDetail.ordered') }}</div>
    <div class="state4"></div>
    <div style="margin-top: 4px;float:left;font-size:20px">{{ $t('recordsList.overdue') }}</div>
    <div class="state5"></div>
    <div style="margin-top: 4px;float:left;font-size:20px">{{ $t('recordsList.info') }}</div>
    <div :key="lang">
      <el-table
        :data="list"
        border
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
        height="600"
        :key="select.isMy"
       v-loading="loading1"
      >
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column
          prop="reportTime"
          :label="$t('recordDetail.reportTime')"
          width="100"
          v-if="!(select.isMy == '1')"
        ></el-table-column>
        <el-table-column prop="reportMan" :label="$t('recordDetail.reporter')" width="75">
                    <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('recordDetail.reporter')}}</div>
            <a-input allow-clear @keyup.enter="ListC()" v-model.trim="queryParams.reportMan" />
          </template>
            <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.reportMan">{{ scope.row.reportMan }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="zz" :label="$t('recordDetail.reporterOrganization')" width="95">
           <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('recordDetail.reporterOrganization')}}</div>
            <a-input allow-clear @keyup.enter="ListC()" v-model.trim="queryParams.zz" />
          </template>
            <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.zz">{{ scope.row.zz }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="company" :label="$t('customer.company')" width="200">
               <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('customer.company')}}</div>
            <a-input allow-clear @keyup.enter="ListC()" v-model.trim="queryParams.company" />
          </template>
            <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.company">{{ scope.row.company }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="companyAddress" :label="$t('customer.address')" width="180">
           <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('customer.address')}}</div>
            <a-input allow-clear @keyup.enter="ListC()" v-model.trim="queryParams.companyAddress" />
          </template>
            <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.companyAddress">{{ scope.row.companyAddress }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="linkman" :label="$t('orders.contactPerson')" width="80">
           <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('orders.contactPerson')}}</div>
            <a-input allow-clear @keyup.enter="ListC()" v-model.trim="queryParams.linkman" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.linkman">{{ scope.row.linkman }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="linkmanNum" :label="$t('device.mobile')" width="110">
           <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('device.mobile')}}</div>
            <a-input allow-clear @keyup.enter="ListC()" v-model.trim="queryParams.linkmanNum" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.linkmanNum">{{ scope.row.linkmanNum }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="policymaker" :label="$t('recordDetail.policymaker')" width="80">
           <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('recordDetail.policymaker')}}</div>
            <a-input allow-clear @keyup.enter="ListC()" v-model.trim="queryParams.policymaker" />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.policymaker">{{ scope.row.policymaker }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column
          prop="policymakerNum"
          :label="$t('recordDetail.policymakerNum')"
          width="110"
        >
         <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('recordDetail.policymakerNum')}}</div>
            <a-input allow-clear @keyup.enter="ListC()" v-model.trim="queryParams.policymakerNum" />
          </template>
      <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.policymakerNum">{{ scope.row.policymakerNum }}</text-highlight>
          </template></el-table-column>

        <el-table-column prop="saleman" :label="$t('orders.receiver')" width="100">
           <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('orders.receiver')}}</div>
            <a-input allow-clear @keyup.enter="ListC()" v-model.trim="queryParams.saleman" />
          </template>
           <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.saleman">{{ scope.row.saleman }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column prop="originalModel" :label="$t('recordDetail.originalModel')" width="100"></el-table-column>
        <el-table-column
          prop="customerDemand"
          :label="$t('recordDetail.customerDemand')"
          width="120"
        >
         <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('recordDetail.customerDemand')}}</div>
            <a-input allow-clear @keyup.enter="ListC()" v-model.trim="queryParams.customerDemand" />
          </template>
        <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.customerDemand">{{ scope.row.customerDemand }}</text-highlight>
          </template></el-table-column>
        <el-table-column
          prop="note"
          :label="$t('common.remark')"
          width="120"
        >
         <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.remark')}}</div>
            <a-input allow-clear @keyup.enter="ListC()" v-model.trim="queryParams.note" />
          </template>
        <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.note">{{ scope.row.note }}</text-highlight>
          </template></el-table-column>
        <el-table-column
          prop="estimatedPurchaseTime"
          :label="$t('recordDetail.estimatedPurchaseTime')"
          width="110"
        ></el-table-column>
        <el-table-column prop="state1" :label="$t('recordsList.state')" width="100"></el-table-column>
        <el-table-column prop="isorder1" :label="$t('recordDetail.isorder')" width="100"></el-table-column>
        <el-table-column
          prop="customerBelong"
          :label="$t('recordDetail.customerBelong')"
          width="120"
        ></el-table-column>
        
        <el-table-column
          prop="customerDemand"
          :label="$t('recordsList.customerDemand')"
          width="120"
          v-if="!(select.isMy == '1')"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.daysDifference > 0 && scope.row.state == '2'"
            >{{ scope.row.daysDifference }}</div>
            <div
              v-if="scope.row.daysDifference <= 0 && scope.row.state == '2'"
            >{{ $t('recordsList.wasDue') }}</div>
            <div v-if="scope.row.state != '2'"></div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="informationSources" label="消息来源" width="110">
        </el-table-column>-->

        <el-table-column :label="$t('common.operation')" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="routeTo(scope.row)">{{ $t('funnel.details') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :key="lang"
      @size-change="ListC1"
      @current-change="ListC"
      :pager-count="9"
      :current-page="pageNo"
      :page-size="limit"
      :page-sizes="[50, 200, 500, 1000]"
      :background="true"
      layout="prev, pager, next, jumper,->, sizes,total"
      :total="total"
      style="margin-top: 10px;"
    />
    <el-dialog
      :title="$t('recordsList.addInfo')"
      :visible.sync="dialogFormVisible"
      @close="guanbi"
      :zIndex="100"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        size="mini"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('recordDetail.reportTime')" prop="reportTime">
          <el-date-picker
            type="date"
            :placeholder="$t('device.selectDate')"
            v-model="ruleForm.reportTime"
            :disabled="true"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('recordDetail.reporter')" prop="reportMan">
          <el-select
            v-model="ruleForm.reportMan"
            filterable
            remote
            reserve-keyword
            :placeholder="$t('recordsList.eun')"
            :remote-method="remoteMethod2"
            :loading="loading"
            style="width: 75%;"
            :disabled="!authorities.find(a => a.code === 'crm:records:update')"
          >
            <el-option
              v-for="item in reuserList"
              :key="item.id"
              :label="
                item.realName + '-' + item.organization + '-' + item.username
              "
              :value="item.realName"
              @click.native="clickThis2(item)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.salesMen')" prop="saleman">
          <el-select
            v-model="ruleForm.saleman"
            filterable
            remote
            reserve-keyword
            :placeholder="$t('recordsList.eun')"
            :remote-method="remoteMethod1"
            :loading="loading"
            style="width: 75%;"
            :disabled="!authorities.find(a => a.code === 'crm:records:update')"
          >
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="
                item.realName + '-' + item.organization + '-' + item.username
              "
              :value="item.realName"
              @click.native="clickThis1(item)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('customer.company')" prop="company">
          <el-select
            v-model="ruleForm.company"
            filterable
            remote
            reserve-keyword
            :placeholder="$t('messages.company_empty')"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width: 75%;"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
              @click.native="clickThis"
            ></el-option>
          </el-select>
          <el-button
            style="margin-left: 18px;"
            @click="baseaddCC"
          >{{ $t('recordDetail.duplicate') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('recordDetail.area')" prop="ssq">
          <el-select
            v-model="p"
            filterable
            :placeholder="$t('recordDetail.province')"
            @change="selectSheng"
            style="width: 25%;"
          >
            <el-option
              v-for="(item, index) in china"
              :key="index"
              :label="item.province"
              :value="item.province"
            ></el-option>
          </el-select>

          <el-select
            v-model="c"
            filterable
            :placeholder="$t('recordDetail.city')"
            @change="selectCity"
            style="width: 25%;"
          >
            <el-option
              v-for="(item, index) in selectedProvince.citys"
              :key="index"
              :label="item.city"
              :value="item.city"
            ></el-option>
          </el-select>

          <el-select
            v-model="area"
            filterable
            :placeholder="$t('recordDetail.region')"
            style="width: 25%;"
            @change="selectArea"
          >
            <el-option
              v-for="(item, index) in areas1"
              :key="index"
              :label="item.area"
              :value="item.area"
            ></el-option>
          </el-select>
          <el-select
            v-model="zhen"
            filterable
            :placeholder="$t('recordDetail.town')"
            style="width: 25%;"
            v-if="area == '慈溪市'"
            @change="selectzhen"
          >
            <el-option v-for="(item, index) in cxzhen" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('customer.address')" prop="companyAddress">
          <el-input v-model="ruleForm.companyAddress"></el-input>
        </el-form-item>
        <el-form-item :label="$t('orders.contactPerson')" prop="linkman">
          <el-input v-model="ruleForm.linkman"></el-input>
        </el-form-item>
        <el-form-item :label="$t('device.mobile')" prop="linkmanNum">
          <el-input v-model="ruleForm.linkmanNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('recordDetail.policymaker')" prop="policymaker">
          <el-input v-model="ruleForm.policymaker"></el-input>
        </el-form-item>
        <el-form-item :label="$t('recordDetail.policymakerNum')" prop="policymakerNum">
          <el-input v-model="ruleForm.policymakerNum"></el-input>
        </el-form-item>
        <!-- <el-form-item label="客户归属" prop="customerBelong">
          <el-input v-model="ruleForm.customerBelong"></el-input>
        </el-form-item>-->
        <el-form-item :label="$t('recordDetail.customerDemand')" prop="customerDemand">
          <el-input v-model="ruleForm.customerDemand"></el-input>
        </el-form-item>
        <el-form-item :label="$t('recordDetail.informationSources')" prop="informationSources">
          <el-select placeholder v-model="ruleForm.informationSources" class="m-2">
            <el-option
              v-for="item in options8"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('recordDetail.originalModel')" prop="originalModel">
          <el-input v-model="ruleForm.originalModel"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('recordDetail.estimatedPurchaseTime')"
          prop="estimatedPurchaseTime"
        >
          <el-input v-model="ruleForm.estimatedPurchaseTime"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.remark')" prop="note">
          <el-input type="textarea" v-model="ruleForm.note"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.picture')" label-width="100px">
          <div class="upload">
            <button
              aria-disabled="false"
              type="button"
              class="el-button el-button"
              :key="fileList.length"
            >
              <span style="padding: 8px 15px;" class @click="showFileModal">
                <i class="el-icon-upload"></i>
                &nbsp;&nbsp;{{ $t('buttons.uploadPic') }}
              </span>
            </button>
            <input
              ref="InputFileDOm"
              class="file"
              type="file"
              :accept="'.mp4,.jpg,.jpeg,.png,.webm'"
              :limit="6"
              @change="hadnleFileCHnage($event, '0')"
              multiple
            />
            <div class="upload-demo" data-v-1ab1ffd8>
              <ul class="el-upload-list el-upload-list--text" :key="fileList.length">
                <li
                  tabindex="0"
                  class="el-upload-list__item is-success"
                  v-for="(file, index) in fileList"
                  :key="index"
                >
                  <!---->
                  <a class="el-upload-list__item-name">
                    <i class="el-icon-document"></i>
                    {{ file.name }}
                  </a>
                  <label class="el-upload-list__item-status-label">
                    <i class="el-icon-upload-success el-icon-circle-check"></i>
                  </label>
                  <i class="el-icon-close" @click="rF(index)"></i>
                  <i class="el-icon-close-tip">{{ $t('recordDetail.delete') }}</i>
                </li>
              </ul>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="guanbi(false)">{{ $t('common.cancelText') }}</el-button>
        <el-button
          type="primary"
          @click="firstQ('ruleForm')"
          :loading="anniu"
        >{{ $t('common.okText') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="Ttitle" :visible.sync="dialogTableVisible" @close="closeTable">
      <el-table :data="zsArray">
        <!-- <el-table-column
          property="reportTime"
          label="日期"
          width="150"
        ></el-table-column>-->
        <el-table-column property="company" :label="$t('customer.company')" min-width="200"></el-table-column>
        <el-table-column property="saleman" :label="$t('common.salesMen')" width="100">
          <template slot-scope="scope">
            <div v-if="Array.isArray(scope.row.saleman)">
              <p v-for="(item, index) in scope.row.saleman" :key="index">{{ item }}</p>
            </div>
            <div v-else>{{ scope.row.saleman }}</div>
          </template>
        </el-table-column>
        <el-table-column property="state" :label="$t('recordDetail.state')" width="170">
          <template slot-scope="scope">
            <div v-if="scope.row.state == '1'">{{ $t('report46.unaudited') }}</div>
            <div v-else-if="scope.row.state == '2'">{{ $t('recordDetail.reportValid') }}</div>
            <div v-else-if="scope.row.state == '3'">{{ $t('recordDetail.reportInvalid') }}</div>
            <div v-else></div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">{{ $t('common.cancelText') }}</el-button>
        <el-button type="primary" @click="jxAdd" v-if="allowTJ">{{ $t('recordDetail.submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="less">
.layout-container-demo .el-main {
  padding: 0;
}

.layout-container-demo .toolbar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  right: 20px;
}

:deep(.el-icon svg) {
  color: inherit !important;
}

input.file {
  display: none;
}

.dotClass {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
  margin-left: 10px;
}
/deep/ .el-table .warning-row {
  background: #f4f207;
}

/deep/ .el-table__body .success-row {
  color: black;
  background: #00ff66;
}
/deep/ .el-table__body .leave-row {
  color: white;
  background: #d65745;
}
/deep/ .el-table__body .not-row {
  color: white;
  background: #1e92f7;
  .el-button {
    color: white;
  }
}
/deep/ .el-table__body .isorder-row {
  color: white;
  background: #5f5f5f;
}
/deep/ .el-table {
  // 每行鼠标经过得样式
  .el-table__body tr td {
    background-color: unset !important;
  }
}
.state1 {
  background: #00ff66;
  height: 30px;
  width: 80px;
  margin-left: 2px;
  margin-top: 5px;
  float: left;
}
.state2 {
  background: #f4f207;
  height: 30px;
  width: 80px;
  margin-left: 10px;
  margin-top: 5px;
  float: left;
}
.state3 {
  background: #5f5f5f;
  height: 30px;
  width: 80px;
  margin-left: 10px;
  margin-top: 5px;
  float: left;
}
.state4 {
  background: #d65745;
  height: 30px;
  width: 80px;
  margin-left: 10px;
  margin-top: 5px;
  float: left;
}
.state5 {
  background: #1e92f7;
  height: 30px;
  width: 80px;
  margin-left: 10px;
  margin-top: 5px;
  float: left;
}

/deep/ .el-scrollbar__wrap::-webkit-scrollbar {
  width: 30px;
  height: 30px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
